export { default } from './TagsInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/TagsInfo/index.js